import { Box, Divider, Flex, chakra } from '@chakra-ui/react';
import Image from 'next/image';
import { Button, Heading, IButtonProps, Paragraph } from 'ui-components';

import { DistributionWrapper } from '../DistributionWrapper';
import PlaceholderCountries from '../static/countries.svg';

export function CountriesDistributionWidget({
  title,
  description,
  button,
}: {
  title: string;
  description?: string;
  button?: IButtonProps;
}) {
  return (
    <DistributionWrapper sx={{ padding: 0 }}>
      <Flex
        flexDir="column"
        position="relative"
        paddingTop="spacing-300"
        paddingX="spacing-400"
        paddingBottom="28px"
        minHeight="413px"
      >
        <Heading size="sm" color="primary.400">
          {title}
        </Heading>
        <Divider color="primary.100" marginTop="spacing-200" />

        <Box position="relative">
          <Box
            background="linear-gradient(180deg, rgba(255, 255, 255, 0) 4.09%, #FFFFFF 52.37%)"
            height="320px"
            width="296px"
            position="absolute"
          />
          <chakra.img
            as={Image}
            src={PlaceholderCountries}
            alt="countries distribution"
            sx={{ marginTop: 'spacing-200' }}
            height="149px"
            width="296px"
          />
        </Box>

        <Flex
          marginTop="auto"
          flexDir="column"
          gap="spacing-200"
          position="relative"
        >
          {description && (
            <Paragraph
              sx={{
                textAlign: 'center',
                minWidth: '302px',
              }}
              size="md"
              fontWeight="medium"
              color="primary.500"
            >
              {description}
            </Paragraph>
          )}

          {button && (
            <Flex justifyContent="center">
              <Button size="sm" {...button}>
                {button.children}
              </Button>
            </Flex>
          )}
        </Flex>
      </Flex>
    </DistributionWrapper>
  );
}
